var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('school.academic.operation.classOperation.teacher_same_confirmation'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }